import React from "react";

import Preparation from "./Preparation";
import SuggestionTable from "./SuggestionTable";
import Error from "./Error";

import { AiSuggestionState } from "src/constants/ai";
import type { RoomId, MessageID } from "src/types";
import type { AiNotificationData } from "src/ts-types";

type Props = {
  currentState: AiSuggestionState;
  data: AiNotificationData;
  messageId: MessageID;
  roomId: RoomId;
};

const SuggestionState = ({ currentState, data, messageId, roomId }: Props) => {
  const isReady = currentState === AiSuggestionState.Ready;

  if (currentState === AiSuggestionState.Preparing) {
    return <Preparation />;
  }

  if (currentState === AiSuggestionState.Error) {
    return <Error />;
  }

  return (
    <SuggestionTable
      data={data}
      messageId={messageId}
      roomId={roomId}
      isDisabled={!isReady}
    />
  );
};

export default SuggestionState;
